import PropTypes from "prop-types"

import Modal from "shared/components/modal"

import styles from "shared/components/web_modal.module.scss"

const FilterCodeModal = ({ visible, onClose }) => {
  return (
    <div className={styles["web-modal"]}>
      <Modal show={visible} includeCloseX={false}>
        <h2 className="text-h2">Add an action first</h2>
        <p className="body-medium">
          Before adding filter code to your Applet, add an action.
        </p>
        <div className={styles.ctas}>
          <button type="button" className="button-tertiary" onClick={onClose}>
            Ok
          </button>
        </div>
      </Modal>
    </div>
  )
}

FilterCodeModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default FilterCodeModal
